/* eslint-disable import/prefer-default-export */
import { TRACKING_KEY, TRACKING_EVENT } from 'shared/constants';

export const trackCompleteStep = (tracking, step) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.COMPLETE_FLOW,
    value: step,
    index: true,
    complex: false,
  };
  tracking.trackEvent(body);
};


export const trackCompleteStepCTA = (tracking, step, option) => {
  const body = {
    event: TRACKING_EVENT.PAYLOAD,
    key: TRACKING_KEY.COMPLETE_FLOW,
    value: `value=${step};option=${option}`,
    index: true,
    complex: true,
  };
  tracking.trackEvent(body);
};
